const APIS = {
    USERS: {
        SIGN_IN: 'sign_in',
        CREATE: 'create_user',
        GET_USER: 'get_user',
        UPDATE_USER: 'update_user',
        CHANGE_PASSWORD: 'edit_password',
    },
    ACCOUNT: {
        OVERVIEW: 'get_user_account_overview',
        TRADE: 'trade',
        GET_BINANCE_KEYS: 'binance_keys',
        ADD_BINANCE_KEYS: 'add_binance_keys',
        REFRESH_ALL_BINANCE_KEYS: 'refresh_all_binance_keys',
        DELETE_BINANCE_KEYS: 'delete_binance_keys',
        UPDATE_BINANCE_TRADING_STATUS: 'update_binance_trading_status',
    }
}

const AUTO_REFRESH_MS = 30000 // each 30 seconds

export { APIS, AUTO_REFRESH_MS }